const PS_CARE_PLUS_ASSET_BASE =
    "https://storage.googleapis.com/ps-asset/affiliate/logo/PSCAREBUNDLE";

/**
 * PolicyStreet Care+ bundle, shown on the comparison page whenever the
 * quotation's add-on list contains a `PSCAREPLUS` row.
 *
 * Same split as INSURER_CAR_PLUS_PACKAGE: the DB add-on row carries
 * availability and price, this constant carries the copy. The difference is
 * scope - MyCar Plus is an insurer product and is therefore keyed by insurer
 * name, while Care+ is a partner product, so there is one package and no key.
 * That also means the selection must survive an insurer switch; see
 * initPolicyStreetCarePlus() in comparison.component.ts.
 */
export const POLICYSTREET_CARE_PLUS_PACKAGE = {
    settings: {
        showCheckbox: true,
        showPrice: false,
        isMandatory: false
    },

    code: "PSCAREPLUS",
    banner: {
        en: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_Carsome_Banner-en.png`,
        bm: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_Carsome_Banner-bm.png`
    },
    logo: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_PSLogo.png`,
    title: "addOn.PSCarePlus_Title",
    description: "addOn.PSCarePlus_Desc",

    benefits: [
        {
            image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_PALogo.png`,
            title: "addOn.PSCarePlus_PersonalAccident_Title",
            description: "addOn.PSCarePlus_PersonalAccident_Desc"
        },
        {
            image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_HospLogo.png`,
            title: "addOn.PSCarePlus_HospitalizationIncome_Title",
            description: "addOn.PSCarePlus_HospitalizationIncome_Desc"
        },
        {
            image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_RPLogo.png`,
            title: "addOn.PSCarePlus_RetrenchmentProtection_Title",
            description: "addOn.PSCarePlus_RetrenchmentProtection_Desc"
        },
        {
            image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_ClaimLogo.png`,
            title: "addOn.PSCarePlus_DedicatedClaimsSupport_Title",
            description: "addOn.PSCarePlus_DedicatedClaimsSupport_Desc"
        },
        {
            image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_BRDLogo.png`,
            title: "addOn.PSCarePlus_BatteryReplacementDiscount_Title",
            description: "addOn.PSCarePlus_BatteryReplacementDiscount_Desc"
        },
        {
            image: `${PS_CARE_PLUS_ASSET_BASE}/PSCAREBUNDLE_CMDLogo.png`,
            title: "addOn.PSCarePlus_CarMaintenanceDiscount_Title",
            description: "addOn.PSCarePlus_CarMaintenanceDiscount_Desc"
        }
    ]
};
